define(['../appContext', '../utils/tools'],
function (app, tools) {
    "use strict";

    var v = {};

    /**
     * This is a dictionary of all of the value status objects by it's unique identifier...EK
     */
    v.allValueStatuses = new tools.dictionary();

    /**
     * This is a dictionary of all of the value status objects by it's database status value...EK
     */
    v.valueStatusByValue = new tools.dictionary();

    /**
     * This holds a reference to the not-initialized status object for quick access...EK
     */
    v.notInitializedStatus = null;

    /**
     * This holds a reference to the marked as deleted status object for quick access...EK
     */
    v.markedAsDeletedStatus = null;

    /**
     * This functions sets the cached status objects that are used for special status checking cases...EK
     */
    v.setStoredStatuses = function () {

        //Find the value status Value that is null (this is the not initialized Status) ... EK
        v.notInitializedStatus = v.allValueStatuses.Values.find(vs => vs.StatusValue == null);

        // Find the Mark as Deleted status and store it (note: if we don't have tuneOptionSettings, we have an old service - this is wrapped so we avoid hard error) ... EK
        if (app.dv.cache.session.config.tuneOptionSettings != null && app.dv.cache.session.config.tuneOptionSettings.DeletedRecordStatusID != null) {
            var markedAsDelStatus = app.dv.cache.session.config.tuneOptionSettings.DeletedRecordStatusID;
            v.markedAsDeletedStatus = v.allValueStatuses.Values.find(vs => vs.UID === markedAsDelStatus.UID);
            if (app.dv.cache.session.config.tuneOptionSettings.KeepDeletedRecords && (v.markedAsDeletedStatus == null || v.markedAsDeletedStatus.StatusValue == null)) {
                console.warn(`The 'Marked as Deleted' status has a Null value - it should not be used. Please select another status for Marked as Deleted (System Settings - Data Retention).`)
            }
        }
    };

    /**
     * Will return a status of the given name (val), will return null if not found...EK
     */
    v.getValueStatusByName = function (val) {
        var sl = v.allValueStatuses.Values;
        for (var i = 0, il = sl.length; i < il; i++) {
            var s = sl[i];
            if (s.Name == val) {
                return s;
            }
        }
        return null;
    };

    /**
     * This will send a service call to get the latest (largest) StatusValue field value for value statuses...WR
     * @returns {Promise} resolves with the service return value and/or error object.
     */
    v.getLatestStatusValue = async function () {
        //Make the call...EK
        let result, err;
        try {
            result = await app.dv.services.call(app.dv.services.endpoints.getLatestStatusValue, { Session: app.dv.cache.session.sessionGUID });
        } catch (e) {
            err = e;
        }

        if (result == null || err != null) {
            // if we do not have a result, we have an error!
            throw new Error(`Unable to get return value from service. ${(err && err.message) || err || ""}`);
        }
        else {
            return result;
        }
    };

    v.applyClientProperties = function (entity) {
        if (entity == null) { return; }
        entity.clientProperties = new app.dv.entities.ClientProperties(app.dv.types.EntityTypes.ValueStatus);
    };

    return v;
});
